export default function parchmentSSO() {
    return {

       sessionId: '',
       peopleCodeId: '',
        url: '',
        partnerKey: '',
        nonce: '',
        token: '',
       queryString:'',
        
        bindParchmentSSO() {
           
            fetch('/api/Parchment/GetParchmentSSO', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    if (response != undefined && response.isSuccess) {
                        this.sessionId = response.sess;
                        this.peopleCodeId = response.peopleCodeId;
                        this.url = response.url;
                        this.partnerKey = response.partnerKey;
                        this.nonce = response.nonce;
                        this.token = response.token;
                        this.queryString = response.queryString;
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }

                });

        },
        
        init() {
            this.bindParchmentSSO();

        }
    }
}